<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <v-card class="vb-select-folder-card" data-cy="dialog---">
      <v-card-title class="d-flex justify-space-between" data-cy="dialog---">
        {{$t('routes.users.updateAccessPoint')}}

        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text scrollable  class="scrollable mt-2 pb-0">
        <div>{{ $t('routes.users.confirmAccesspointUpdate') }}</div>

        <!-- <div v-show="successMessage" class="success" data-cy="dialog-createTranscript-successMessage">{{successMessage}}</div> -->
        <div v-show="errorMessage" class="bg-error" data-cy="dialog-createTranscript-errorMessage">{{errorMessage}}</div>
        <div v-if="errorTranslatable" class="bg-error">
          {{$replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content)}}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="updateAccessPoint"
          :disabled="updateButtonDisabled"
          class="bg-primary"
          elevation="0"
          data-cy="dialog---"
        >
          {{$t('common.update')}}
        </v-btn>
        <v-btn variant="text" @click="close" data-cy="dialog---">{{$t('common.cancel')}}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { useUserStore } from '@/stores/UserStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["dialogClosed", 'update:modelValue'],
  mixins: [DialogActionKeys],
  name: "AccesspointUpdateDialog",

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    oldNodeId: {
      type: String,
      required: true,
    },
    newNodeId: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      // dialog: false,
      errorMessage: '',
      errorTranslatable: null,
      updateButtonDisabled: false,
    };
  },

  watch: {
    showDialog(newValue) {
      if (newValue) {
        this.resetDialog();
      }
    }
  },

  methods: {
    resetDialog() {
      this.errorMessage = '';
      this.errorTranslatable = null;
      this.updateButtonDisabled = false;
    },
    close() {
      this.showDialog = false;
      this.$emit('dialogClosed', true);
    },
    updateAccessPoint() {
      this.updateButtonDisabled = true;

      let self = this;
      const payload = {
        userId: this.user.id,
        oldAccessPointId: this.oldNodeId,
        newAccessPointId: this.newNodeId,
      };

      const userStore = useUserStore();
      userStore.updateAccesspoint(payload)
      .then(function() {
        self.close();
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            self.errorTranslatable = apiError;
          } else {
            self.errorMessage = apiError;
          }
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });
    },
  },

  computed: {
    showDialog: {
      get () {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>
